import state from './CombinedBill/states'
import mutations from './CombinedBill/mutations'
import actions from './CombinedBill/actions'
import getters from './CombinedBill/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
